// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lCQZ","name":"styles_name__3rr_F","phone":"styles_phone__2jltf"};